import React from "react";
import ModalBasic from "./ModalBasic";

const ProspectConversionModal = ({ isOpen }) => {
  return (
    <ModalBasic
      modalOpen={isOpen}
      setModalOpen={() => {}} // Prevent closing
      title="Setting Up Your Store"
      width="sm"
      hideCloseButton={true}
    >
      <div className="flex flex-col items-center justify-center py-8">
        <svg
          className="animate-spin w-12 h-12 text-indigo-500 mb-4"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <p className="text-slate-600 dark:text-slate-400 text-center">
          Please wait while we get your store setup
        </p>
      </div>
    </ModalBasic>
  );
};

export default ProspectConversionModal;

